module.exports = __webpack_public_path__ + "static/img/RAPU_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPU_1.png
// module id = vTYB
// module chunks = 0